export let SystemPages = {
  CustomField: 73,
  JobRegionId: 24,
  ApplicationTemplate: 7,
  SystemUser: 51,
  AssessmentForm: 61,
  QuestionBank: 22,
  TimedForms: 75,    /// Actual 75
  DepartmentId: 10,
  JobCategoryId: 9,
  JobLevelId: 17,
  AdvertId: 4,
  SalaryBandsId: 59,
  EthnicOrigins: 16,
  AdvertCategoryId: 3,
  AddressBookId: 2,
  DivisionId: 11,
  SchoolSubjectId: 26,
  CampaignId: 58,
  JobTitleId: 18,
  LocationId: 21,
  SchoolLocationId: 25,
  AgencyId: 5,
  CandidateApplicationStatusId: 6,
  Emails: 14,
  EmailInbox: 12,
  EmailOutbox: 13,
  WorkLevelId: 170,
  Letters: 19,
  Contracts: 167,
  ContractSection: 166,
  Sms: 30,
  SMSInbox: 27,
  SMSOutbox: 28,
  JobCodeId: 171,
  MediaText: 162,
  MediaVideo: 163,
  MediaImage: 164,
  GBGroupPinId: 172,
  PackageId: 174,
  CostCentreId: 175,
  SkillId: 77,
  SkillCategoryId: 76,
  SecurityRoles: 45,
  DocumentLibraryId: 151,
  LibraryTypeId: 153,
  MediaTextId_OB: 179,
  MediaVideoId_OB: 178,
  MediaImageId_OB: 159,
  JTForms: 78,
  JobAlertResults: 168,
  CandidateSearchResults: 180,
  Jobs: 1,
  TeamId: 46,
  AuthorisationUserId: 64,
  AuthorisationTemplateId: 72,
  ApplicationSearch: 169,
  SavedSearches: 41,
  MultiDocumentUploadId: 176,
  SavedCandidateSearch: 160,
  TalentPoolId: 38,
  TalentListId: 258,
  GreenRoomTemplateId: 155,
  KeyContactsId: 158,
  LinkId: 157,
  ManagerId: 156,
  SettingId: 150,
  TalentPoolCandidateId: 35,
  AlertList: 7,
  CandidateListByJob: 165,
  OnBoardingTemplateId: 152,
  OnBoardingFormId: 154,
  CalendarId: 67,
  EventId: 79,
  MyCandidateAlertId: 182,
  MySavedAlertId: 183,
  MyTextMessageId: 184,
  MyAuthorizationId: 181,
  MyEnhancedAuthorizationId: 366,
  MyStarterId: 185,
  TalentSearchResults: 187,
  KeywordSearchResults: 188,
  MyCandidateShortListing: 186,
  MyOfferAuthorization: 189,
  SystemAlertId: 190,
  DocumentsLibraryId: 60,
  StatusChangeReasonId: 191,
  SystemPipelineId: 192,
  RecentlyUploaded: 193,
  RecentlyUploadedDetail: 194,
  MyEmailId: 195,
  SourceTracking: 196,
  NhsAccountCodes: 197,

    NhsCostCodes: 256,
    BoardPosition: 257,
    AllocatedCandidates: 251,
    UnAllocatedCandidates: 252,
    NewCandidates: 253,
    DeferredCandidates: 254,
    ReminderCandidates: 255,
    LibraryTypeIdCompliance: 281,
    DocumentLibraryIdCompliance: 282,
    ComplianceFormId: 284,
    ComplianceTeamId: 285,
    OnBoardingStatusId: 286,
    ComplianceTemplateId: 283,
    OnBoardingHubOverwiewId: 287,
    OnBoardingHubManagerId: 288,
    SpecialtiesId: 289,
    JobTemplates: 295,
    OnBoardingHubReferenceId: 300,
    OnBoardingHubOnboardingId: 301,
    OnBoardingHubComplianceId: 302,
    SpecialismsId: 303,
    SearchJobs: 304,
    OnBoardingImageId: 305,
    OnBoardingTextId: 306,
    OnBoardingVideoId: 307,
    NhsBanks: 308,
    DelAndAppWithdrawReasonsId: 310,
    MyLocumCandidateId: 311,
    NylasAccounts: 312,
    NHSStaffGroups: 313,
    NhsJobDescriptions: 314,
    GgbKypShortCodesId: 315,
    UserLog: 316,
    BookedInterviewsId: 325,
    NHSJKLBand: 330,
    NHSAvailabilitySupplement: 331,
    Positions: 332,
    VonqOrderReceiptId: 326,
    VonqCampaigns: 321,
    VonqCampaignsDetail: 322,
    PostJobCampaigns: 323,
    PostJobCampaignsDetail: 324,
    MasterAccount: 329,
    MyReferences: 333,
    ColleagueCategory: 338,
    WorkPatterns: 339,
    ObHubAction: 337,
    PostReference: 342,
    ESRVacanyList: 345,
    ESRApplicantList: 346,
    ESREmploymentList: 348,

    InvitationHistory: 365,
    TalentPoolTemplateId: 351,
    TalentNetworkId: 352,
    TalentPoolCandidateList: 371,
    TalentPoolProfile: 367,
    CRMTalentPoolId: 353,
    RedeploymentCases: 372,
    RedeploymentStatus: 373,
    RedeploymentFormId: 374,
    RedeployeeWithdrawReasons: 368,
    RedeploymentPreviousCases: 376,
    FundingSourceId: 343,
    AuthorisationGroup: 344,
    PublicReportLibraryId: 360,
    ContractImageId: 361,

}
